import React from 'react';

import moment from 'moment'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {AutocompleteInput, DateInput, ReferenceInput, required, Title} from 'react-admin';
import {PaymentMethodInput, ReportForm, schoolYears, showErrorNotify, TreeCheckboxInput} from '../../components';
import env from '../../env';
import {downloadFilePost} from "../../components/FileDownload";

class BangKeTungDanhMuc extends React.Component {
    state = {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        pProductIds: [],
        changeSchoolYear: false,
        unitIds: [],
        schoolYearId: schoolYears[0].id,
        paymentMethod: ''
    };

    excelReport = async () => {
        if (!this.state.pProductIds || this.state.pProductIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách phí")
            return;
        }
        let data = {
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            productIds: this.state.pProductIds,
            schoolYearId: this.state.schoolYearId,
            unitIds: this.state.unitIds
        }
        if (this.state.paymentMethod) {
            data = {
                ...data,
                paymentMethod: this.state.paymentMethod
            }
        }
        await downloadFilePost(`${env.reportURL}/reports/bangKeTungDanhMuc`, 'bang_ke_thu_theo_danh_muc.xlsx', data)
    };

    validate = (values) => {
        const errors = {};

        // Validate
        if (values.fromDate && values.toDate && (values.fromDate > values.toDate)) {
            errors.toDate = 'To date must be greater than From date'
        }
        this.setState({
            fromDate: values.fromDate,
            toDate: values.toDate,
            pProductIds: values.productIds,
            paymentMethod: values.paymentMethod,
        });

        if (this.state.changeSchoolYear) {
            this.setState({
                unitIds: [],
                changeSchoolYear: false
            })
        } else {
            this.setState({
                unitIds: values.unitIds
            })
        }

        return errors;
    };

    onSchoolYearChanged(e, value) {
        this.setState({
            schoolYearId: value,
            changeSchoolYear: true
        });
    }

    render() {
        return (
            <Card>
                <Title title="resources.bangKeTungDanhMuc.name"/>
                <CardContent>
                    <ReportForm params={this.state}
                                validate={this.validate}
                                excelReport={this.excelReport}
                    >
                        <Grid container spacing={8}>
                            Báo cáo tính số tiền theo kế hoạch thu được đưa lên hệ thống
                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <DateInput label="resources.common.fromDate" source="fromDate"
                                           validate={required()} {...this.props} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DateInput label="resources.common.toDate" source="toDate"
                                           validate={required()} {...this.props} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <PaymentMethodInput source="paymentMethod"/>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label>Danh sách phí *</label>
                                <div style={{maxHeight: '300px', overflow: 'auto'}}>
                                    <ReferenceInput source="productIds"
                                                    reference="billProducts"
                                                    perPage={999}
                                                    {...this.props} >
                                        <TreeCheckboxInput optionValue="id"
                                                           optionText="name"
                                                           expandTopLevel={true}
                                                           hideDeleted
                                                           optionDeleteProp='enable'
                                                           labelRender={item => `${item.id} - ${item.name}`}
                                        />
                                    </ReferenceInput>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <ReferenceInput source="schoolYearId"
                                                reference="schoolYears"
                                                label="resources.schoolYears.name"
                                                perPage={50}
                                                validate={required()}
                                                onChange={(e, value) => this.onSchoolYearChanged(e, value)}
                                                {...this.props} >
                                    <AutocompleteInput source="name"/>
                                </ReferenceInput>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label>Danh sách lớp</label>
                                <div style={{maxHeight: '300px', overflow: 'auto'}}>
                                    <ReferenceInput source="unitIds"
                                                    reference="units"
                                                    perPage={999}
                                                    filter={{
                                                        clazzWithParents: true,
                                                        schoolYear: this.state.schoolYearId
                                                    }}
                                                    {...this.props} >
                                        <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                                    </ReferenceInput>
                                </div>
                            </Grid>
                        </Grid>
                    </ReportForm>

                </CardContent>
            </Card>
        )
    }
}

export default BangKeTungDanhMuc

